// extracted by mini-css-extract-plugin
export default {"modalDialog":"BackupModal-module__modalDialog"};